// Patch 32 · same level curve and unlock levels as the server (backend/core/xp.py and core/unlocks.py).
export const UNLOCK_LEVEL = { garden: 2, fish: 3, shop: 5 };

const xpToNext = (level) => (level <= 14 ? 60 + 20 * (level - 1) : Math.round(340 * 1.1 ** (level - 14)));

export function levelFromXp(total) {
  let xp = Math.max(0, Number(total) || 0);
  let level = 1;
  while (xp >= xpToNext(level)) {
    xp -= xpToNext(level);
    level += 1;
  }
  return level;
}
